import { z } from 'zod'

import type { Language } from '@nxt-insurance/constants'

import { legalRolandSchema } from '@flows/configs/de/legalRoland/types'
import type { generateGetFlowValueFunctions } from '@flows/insurance/utils'

export interface LegalRolandStepParams {
  getCurrentLanguage: () => Language
  helperFunctions: ReturnType<typeof generateGetFlowValueFunctions>
  environment: string
  platform: 'web' | 'native'
}

export const employmentSchema = z.object({
  products: z.object({
    mga_legal_roland_de: z.object({
      configuration_parameters: legalRolandSchema.pick({
        employment_status: true,
      }),
    }),
  }),
})

export const insuredPartiesSchema = z.object({
  products: z.object({
    mga_legal_roland_de: z.object({
      configuration_parameters: legalRolandSchema.pick({
        insured_parties: true,
      }),
    }),
  }),
})

export const previousInsuranceGotCanceledSchema = z.object({
  products: z.object({
    mga_legal_roland_de: z.object({
      configuration_parameters: legalRolandSchema.pick({
        previous_insurance_got_canceled: true,
      }),
    }),
  }),
})

export const successSchema = z.object({})
